import React from 'react'
import img from '../../assets/Images/Img6.png'
import './experience.css'
import { experienceData } from '../../DataFiles/ExperienceData'
const Experience = () => {
    return (
        <div className="experienceSection row overflow">
            <div className="col-lg-6 col-md-12 rightleftSide" data-aos="fade-right">
                <div className="experienceBox">
                    <h3 className='sectionIntro' style={{ color: "white" }}>Experience:</h3>
                    <div className="experience2">
                    {experienceData.map((exp)=>(
                        <div className="experience" style={{backgroundColor:`${exp.color}`, color:`${exp.color2}` ,border:`2px solid ${exp.color2}`}} key={exp.id}>
                        <h5>{exp.role}</h5>
                        <img src={exp.logo} alt="" />
                        <h5>{exp.companyName}</h5>
                        <i class="fas fa-calendar-alt"></i>
                        <p>{exp.duration}</p>
                    </div>
                    ))}
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-md-12 rightleftSide image" data-aos="fade-left">
                <img src={img} alt="" />
            </div>

        </div>
    )
}

export default Experience